import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { LoanCommissionStore } from '../stores';

export const useLoanCommissionStore = () => useContext<{
  loanCommissionStore: LoanCommissionStore
}>(StoreContext);
